/**
 * Created by vetal on 15.11.16.
 */
define('plugin/pwa/PwaPlugin',['require','lib/plugin/PluginAbstract','lib/AppRouter','plugin/pwa/model/PwaModel','plugin/pwa/model/PwaDeviceModel','plugin/pwa/view/PwaPushView','lib/theme/ThemeSettings','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AppRouter = require('lib/AppRouter');
    var PwaModel = require('plugin/pwa/model/PwaModel');
    var PwaDeviceModel = require('plugin/pwa/model/PwaDeviceModel');

    var PwaPushView = require('plugin/pwa/view/PwaPushView');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');

    return PluginAbstract.extend({

        _collection : null,
        _moduleView: null,
        _pwaModel: null,
        _pwaDeviceModel: null,
        _clientModel: null,

        _pwaModuleRegions: {
            pwa_notification: '#sb_pwa_push_notifications'
        },

        initialize: function () {
            this._pwaModel = new PwaModel();
            this._pwaDeviceModel = new PwaDeviceModel();
            var config = Config.getInstance();

            //console.log(121212);
            this._clientModel = this.getOption('clientModel');
        },

        _initNotifications : function (){
        },


        initStepManagerEvents: function () {
            this._bookingModel = this._stepManager.getBookingModel();

            this.listenTo(this._stepManager.getBookingModel(), 'change:start_date',  this._setPwaDevice);
        },

        /**
         * On show client bookings page.
         * If we got cart_id we will load cart status from server
         *
         * @param BookingResultView view
         * @param Object data
         */
        onShowClientBookings: function (view, data) {
            // this._redirectHome();
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         */
        onFinishPayment: function (view, data) {

        },

        /**
         * On finish booking
         *
         * @param view
         * @param data
         */
        onFinishBooking: function (data) {

        },

        _getPwaPushView: function (handler) {
            //console.log(1212122222);
            var _this = this;
            if(_this._moduleView){
                handler(_this._moduleView);
            }

            if(_this._moduleViewC){
                return ;
            }

            _this._moduleViewC = true;
                //console.log(_this._pwaModel);
            new Promise(function(resolve, reject) {
                _this._pwaDeviceModel.on('sync', function () {
                    resolve(true);
                }).fetch();

            }).then(function() {
                _this._moduleView = new PwaPushView({
                    model: _this._pwaModel,
                    clientModel: _this._clientModel,
                    deviceModel: _this._pwaDeviceModel,
                    mode : _this.getPwaMode(),
                });

                handler(_this._moduleView);
            });

        },

        initModules: function (view) {
            var _this = this;

            _.each(this._pwaModuleRegions, function (selector, pwaModuleRegions) {
                view.addRegion(pwaModuleRegions, selector);
            });

            if(this.isPWA()) {
                if (view.pwa_notification.$el.length) {
                    _this._getPwaPushView(function (pushView) {
                        //console.log(pushView);
                        //if (!_this._moduleView || _this._moduleView.isDestroyed) {
                        view.pwa_notification.show(pushView);
                        //}
                    });
                } else {
                    //console.log('oooo');
                    _this._pwaDeviceModel.fetch();
                }
            }
        },

        _redirectWithReplace: function (path, options) {
            if (_.isUndefined(options)) {
                options = {
                    trigger: true,
                    replace: true
                };
            }
            Backbone.history.navigate(path, options);
        },

        isPWA : function (){
            if (location.protocol !== 'https:') {
                return false;
            }
            if (window.matchMedia('(display-mode: standalone)').matches) {
                return true;
            }
            if(ThemeSettings.getInstance().getThemeName() === 'pwa'){
                return true;
            }
            //TODO: comment this, only for test
            if(ThemeSettings.getInstance().getThemeName() === 'default'){
                return true;
            }
            return false;
        },

        _setPwaDevice : function (){
            if(this.isPWA()){
                if(this._pwaDeviceModel && this._pwaDeviceModel.get('token')) {
                    //console.log(this._pwaDeviceModel.get('token'));
                    this._stepManager.getBookingModel().set('pwa_device', this._pwaDeviceModel.get('token'));
                }
            }
        },

        /**
         *
         * @returns {string} browser, standalone-ios or standalone
         */
        getPwaMode : function (){
            var displayMode = 'browser';
            if (navigator.standalone) {
                displayMode = 'standalone-ios';
            }
            if (this.isPWA()) {
                displayMode = 'standalone';
            }

            return displayMode;
        }
    });

});
